import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const slice = createSlice({
    name: "phoneCalls",
    initialState: {
        list: [],
        loading: false,
        lastFetch: null,
        addedStatus:false,
        deletedStatus:false,
        deleteLoading:false,
        updatedStatus:false,
    },
    reducers: {
        phoneCallRequestStarted: (phoneCalls) => {
            phoneCalls.loading = true;
            phoneCalls.addedStatus = false;
            phoneCalls.deletedStatus = false;
            phoneCalls.updatedStatus = false;
        },
        phoneCallRequestFailed: (phoneCalls) => {
            phoneCalls.loading = false;
        },
        phoneCallsReceived:(phoneCalls,action)=>{
            phoneCalls.list=action.payload;
            phoneCalls.addedStatus=false;
            phoneCalls.deletedStatus=false;
            phoneCalls.updatedStatus=false;
            phoneCalls.loading = false;
        },
        phoneCallAdded:(phoneCalls,action)=>{
            phoneCalls.addedStatus=true;
            phoneCalls.loading = false;
        },
        phoneCallDeleteStarted:(phoneCalls)=>{
            phoneCalls.deleteLoading=true;
        },
        phoneCallDeleted:(phoneCalls,action)=>{
            phoneCalls.deletedStatus=true;
            phoneCalls.deleteLoading=false;
        },
        phoneCallUpdated:(phoneCalls,action)=>{
            phoneCalls.updatedStatus=true;
            phoneCalls.loading = false;
        },
        
    }
});

export const { phoneCallsReceived, phoneCallAdded,
    phoneCallDeleteStarted, phoneCallDeleted, phoneCallUpdated,
    phoneCallRequestStarted, phoneCallRequestFailed } = slice.actions;
export default slice.reducer;

export const loadAppPhoneCalls = (id) => apiCallBegan({
    url: config.GetPhoneCallHistory + id,
    onStart: { type: phoneCallRequestStarted.type },
    onError: { type: phoneCallRequestFailed.type },
    onSuccess: phoneCallsReceived.type
});

export const addAppPhoneCall = (data) => apiCallBegan({
    url: config.AddPhoneCall,
    method:"post",
    data:data,
    onStart: { type: phoneCallRequestStarted.type },
    onError: { type: phoneCallRequestFailed.type },
    onSuccess: phoneCallAdded.type
});

export const updateAppPhoneCall = (data) => apiCallBegan({
    url: config.UpdatePhoneNotes,
    method:"post",
    data:data,
    onStart: { type: phoneCallRequestStarted.type },
    onError: { type: phoneCallRequestFailed.type },
    onSuccess: phoneCallUpdated.type
});

export const deleteAppPhoneCall = (data) => apiCallBegan({
    url: config.DeletePhoneNotes,
    method:"post",
    data:data,
    onStart: { type: phoneCallDeleteStarted.type },
    onSuccess: phoneCallDeleted.type
});

export const getAppPhoneCalls = createSelector(
    state => state.entities.phoneCalls,
    phoneCalls => phoneCalls.list
);

export const getAppPhoneCallsLoading = createSelector(
    state => state.entities.phoneCalls,
    phoneCalls => phoneCalls.loading
);

export const getAppPhoneCallsAddedStatus = createSelector(
    state => state.entities.phoneCalls,
    phoneCalls => phoneCalls.addedStatus
);

export const getAppPhoneCallsDeletedStatus = createSelector(
    state => state.entities.phoneCalls,
    phoneCalls => phoneCalls.deletedStatus
);

export const getAppPhoneCallsDeleteLoading = createSelector(
    state => state.entities.phoneCalls,
    phoneCalls => phoneCalls.deleteLoading
);

export const getAppPhoneCallsUpdatedStatus = createSelector(
    state => state.entities.phoneCalls,
    phoneCalls => phoneCalls.updatedStatus
);
